import React from 'react';

const Offers = () => {
 return (
  <>
   <p className='Offers'>
    <span className='OfferSpan'>Try it free 7 days</span>
    <span>&nbsp;then $20/mo. thereafter&nbsp;</span>
   </p>
  </>
 );
};

export default Offers;
